// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import Swiper from "swiper/bundle";
//--------------------------------------------------------------------//

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import "./slider-text-img.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const sliderTextImg = () => {
    let allSliderTextImg = document.querySelectorAll(".slider-text-img");

    if (!allSliderTextImg.length) return;

    allSliderTextImg.forEach((el, i) => {
        let arrowPrev = el.querySelector(".swiper-button-prev");
        let arrowNext = el.querySelector(".swiper-button-next");

        let pagination = el.querySelector(".swiper-pagination");

        let typePagination = "bullets";

        if (pagination) {
            switch (true) {
                case pagination.classList.contains("bullets"):
                    typePagination = "bullets";
                    break;
                case pagination.classList.contains("fraction"):
                    typePagination = "fraction";
                    break;
                case pagination.classList.contains("progressbar"):
                    typePagination = "progressbar";
                    break;
                default:
                    typePagination = "bullets";
                    break;
            }
        }

        let args = {
            breakpoints: {
                0: {
                    slidesPerView: 1.1,
                    spaceBetween: 24,
                },
                390: {
                    slidesPerView: 1.2,
                    spaceBetween: 24,
                },
                450: {
                    slidesPerView: 1.4,
                    spaceBetween: 24,
                },
                530: {
                    slidesPerView: 1.6,
                    spaceBetween: 24,
                },
                570: {
                    slidesPerView: 1.8,
                    spaceBetween: 24,
                },
                688: {
                    slidesPerView: 2.2,
                    spaceBetween: 24,
                },
                768: {
                    slidesPerView: 2.4,
                    spaceBetween: 30,
                },
                800: {
                    slidesPerView: 3.4,
                    spaceBetween: 30,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                1800: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
                2000: {
                    slidesPerView: 5,
                    spaceBetween: 30,
                },
                2500: {
                    slidesPerView: 6,
                    spaceBetween: 30,
                },
            },

            navigation: {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },

            pagination: {
                el: pagination,
                dynamicBullets: true,
                clickable: true,
                type: typePagination,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
                firstSlideMessage: "This is the first slide",
                lastSlideMessage: "This is the last slide",
                paginationBulletMessage: "Go to slide {{index}}",
                notificationClass: "swiper-notification",
            },
        };

        new Swiper(el.querySelector(".swiper-container"), args);
    });
};

export default sliderTextImg;

//--------------------------------------------------------------------//
